export const CLAIMABLE_ITEMS = ["review"];